// extracted by mini-css-extract-plugin
export default {"pageHeader":"pageHeader__3A5fki8TXsM7CEI569rijI","pageHeaderControls":"pageHeaderControls__148clZpI2TaO1EJfL6OG9T","cornerShadow":"cornerShadow__P99DEnuj6D_1tYiV51Qd3"};